if (!customElements.get('personalize-button')) {
  customElements.define(
    'personalize-button',
    class PersonalizeButton extends HTMLElement {
      static TRIGGER_SELECTOR = '.tcustomizer-btn.tcustomizer-btn--widget.tcustomizer-btn--custom.tcustomizer-btn--trigger';

      connectedCallback() {
        this.addEventListener('click', () => this.handleClick());
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.handleClick();
        });

        if (this.popup) return;

        this.trigger = document.querySelector(PersonalizeButton.TRIGGER_SELECTOR);

        if (!this.trigger) {
          this.watchForTrigger();
        }
      }

      // The sticky ATC copy of the button has no popup of its own, so fall back to the page's one.
      get popup() {
        const productForm = this.closest('product-form');
        return (productForm && productForm.querySelector('personalization-popup')) || document.querySelector('personalization-popup');
      }

      disconnectedCallback() {
        if (this.readyObserver) this.readyObserver.disconnect();
        if (this.clickObserver) this.clickObserver.disconnect();
      }

      watchForTrigger() {
        this.readyObserver = new MutationObserver(() => {
          const trigger = document.querySelector(PersonalizeButton.TRIGGER_SELECTOR);
          if (!trigger) return;
          this.trigger = trigger;
          this.readyObserver.disconnect();
        });
        this.readyObserver.observe(document.body, { childList: true, subtree: true });
      }

      handleClick() {
        const popup = this.popup;
        if (popup && popup.isReady) {
          popup.open();
          return;
        }

        // Fallback to the legacy tcustomizer widget when the popup isn't rendered (e.g. no letters configured).
        if (this.trigger) {
          this.trigger.click();
          return;
        }

        if (this.clickObserver) return;

        this.clickObserver = new MutationObserver(() => {
          const trigger = document.querySelector(PersonalizeButton.TRIGGER_SELECTOR);
          if (!trigger) return;
          this.trigger = trigger;
          this.clickObserver.disconnect();
          this.clickObserver = null;
          trigger.click();
        });
        this.clickObserver.observe(document.body, { childList: true, subtree: true });
      }
    },
  );
}
